import React, { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { EnvironmentSelectors } from 'reactApp/modules/environment/environment';
import { getFeatureABDisableAdsSnackbar } from 'reactApp/modules/features/features.selectors';
import { EPromoAction, sendPromoAnalytics } from 'reactApp/modules/promo/promo.analytics';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { getAdvDisableLink } from 'reactApp/ui/AdvBanners/AdvBanners.helpers';
import { noop } from 'reactApp/utils/helpers';

import { DisableButtonComponent } from './DisableButtonComponent';

interface IProps {
    text?: string;
    className?: string;
    onClick?: () => void;
    id?: string;
}

// места где показываем кнопку https://jira.vk.team/browse/CLOUDWEB-12562
export const DisableButton = ({ text = 'Отключить рекламу', className = '', onClick = noop }: IProps) => {
    const isAnonymous = useSelector(UserSelectors.isAnonymous);

    // tempexp_13536-start
    const storage = useSelector(getCurrentStorage);
    const isPhone = useSelector(EnvironmentSelectors.isPhone);
    const snackbarFeatureName = useSelector(getFeatureABDisableAdsSnackbar);
    const isSnackbarFeatureEnabled = !isPhone && snackbarFeatureName;

    useEffect(() => {
        if (isSnackbarFeatureEnabled && snackbarFeatureName !== 'b') {
            sendPromoAnalytics({ 
                action: EPromoAction.SHOW, 
                name: 'disable-adv-button', 
                source: storage, 
            });
        }
    }, []);

    const handleOnClick = useCallback(() => {
        if (isSnackbarFeatureEnabled && snackbarFeatureName !== 'b') {
            sendPromoAnalytics({ 
                action: EPromoAction.CLICK, 
                name: 'disable-adv-button', 
                source: storage, 
                name_button: 'disable-adv',
            });
        }

        onClick();
    }, [])

    if (isSnackbarFeatureEnabled && snackbarFeatureName === 'b') {
        return null;
    }
    // tempexp_13536-end

    const href = getAdvDisableLink({ isAnonymous });

    return <DisableButtonComponent text={text} href={href} onClick={handleOnClick} className={className} />;
};
